import {query} from 'api';
import ArticleSlide from './articleSlide';
import ArticleList from './articleList';
import PropTypes from 'prop-types';
import {Container, Slides} from './styles';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: false,
  variableWidth: true,
};

const Articles = ({data}) => {
  if (!data) return null;
  const pageTitle = data.acf.dossiers_titre;
  const subTitle = data.acf.recettes_sous_titre;

  return (
    <Container className="slides">
      <Slides {...settings}>
        {data.acf.dossiers_slider.map(slideData => (
          <ArticleSlide
            {...slideData}
            pageTitle={pageTitle}
            subTitle={subTitle}
            key={slideData.dossiers_slider_image}
            id={
              slideData.dossiers_slider_image_mobile
                ? slideData.dossiers_slider_image_mobile
                : slideData.dossiers_slider_image
            }
            type="media"
          />
        ))}
      </Slides>
      <ArticleList />
    </Container>
  );
};

Articles.propTypes = {
  data: PropTypes.object,
};

export default Articles |> query('getArticlePage', {loadingFullWidth: true});
